module.exports = __webpack_public_path__ + "media/images/application/template/SAF-email-header-dd4fc64ab9a0e86931d7bb9ed92eb8db.png";